import { assertNever } from 'owa-assert';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import { trace } from 'owa-trace';
import { getIsDarkTheme } from 'owa-fabric-theme';

const assets = new Map<string, AssetDescriptor>();

export function registerAsset<Payload>(asset: AssetDescriptor<Payload>) {
    const { type } = asset;
    if (assets.has(type)) {
        assertNever(`asset ${type} is already registered` as never);
    }
    assets.set(type, asset as AssetDescriptor);
    return asset;
}

export function getAssetDescriptor(assetType: string) {
    const descriptor = assets.get(assetType);
    if (!descriptor) {
        trace.warn(`unknown asset type: ${assetType}`);
    }
    return descriptor && (!descriptor.isAssetEnabled || descriptor.isAssetEnabled())
        ? descriptor
        : undefined;
}

export function getCanvasView(assetType: string) {
    const descriptor = getAssetDescriptor(assetType);
    return descriptor ? descriptor.CanvasView : null;
}

export function getAssetViewStyle(assetType: string) {
    const descriptor = getAssetDescriptor(assetType);
    if (descriptor) {
        return getIsDarkTheme() && descriptor.viewStyleDark
            ? descriptor.viewStyleDark
            : descriptor.viewStyle;
    }
    return null;
}

export function getOptionsPosition(assetType: string) {
    const descriptor = getAssetDescriptor(assetType);
    return descriptor ? descriptor.optionsPosition : null;
}
